import { ADMIN_ENV, type AdminEnv } from '@/lib/env';

/**
 * The event the sidebar's Check-in and the command palette open, per console
 * (LIM-4707). The events themselves are partner_service's config
 * (product/rewards/partner_service/config/events.jsonnet), and admin_api has
 * no route that lists them, so the one in use is named here: dev's and
 * testnet's always-open rehearsal (events_rehearsal.libsonnet) and prod's
 * night in Florianópolis (LIM-4708). Any other event opens by its URL,
 * /events/<code>/check-in. Point prod at the next event when it is
 * configured.
 */
const CHECK_IN_EVENT_CODES: Readonly<Record<AdminEnv, string>> = {
  dev: 'check-in-rehearsal',
  testnet: 'check-in-rehearsal',
  prod: 'floripa-nomads-2026-10-31',
};

export const CHECK_IN_EVENT_CODE = CHECK_IN_EVENT_CODES[ADMIN_ENV];

/** The current event's door page. */
export const CHECK_IN_PATH = `/events/${CHECK_IN_EVENT_CODE}/check-in`;
